
<div class="cellStyle statusCell">
    <div class="statusCircle" [style.background-color]="color"></div>
    <div class="clip-overflow">{{ text }}</div>
</div>

